import Vue from "vue";
import VueRouter from "vue-router";
import overview from "@/views/overview";
import overviewLeft from "@/views/overviewLeft";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "overview",
    component: overview,
  },
  {
    path: "/overviewLeft",
    name: "overviewLeft",
    component: overviewLeft,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
